import { SET_COUNTRIES } from "./mutation-types";

const mutations = {
  [SET_COUNTRIES](state, countries) {
    state.countries = countries;
  },
};

export default mutations;
